import { message } from "antd";
import {
  ADD_TEACHER_REQUEST,
  ADD_TEACHER_SUCCESS,
  ADD_TEACHER_FAIL,
  GET_TEACHERS_REQUEST,
  GET_TEACHERS_SUCCESS,
  GET_TEACHERS_FAIL,
  UPDATE_TEACHER_REQUEST,
  UPDATE_TEACHER_SUCCESS,
  UPDATE_TEACHER_FAIL,
  DELETE_TEACHER_REQUEST,
  DELETE_TEACHER_SUCCESS,
  DELETE_TEACHER_FAIL,
  CLEAR_ERRORS,
} from "../../constants/admin/teachersConstants";
import axios from "../../../axiosInstance";

// Add Teacher
export const addTeacher = (formData) => async (dispatch) => {
  try {
    dispatch({ type: ADD_TEACHER_REQUEST });
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    const { data } = await axios.post(
      "/api/v1/teachers/admin-add-teacher",
      formData,
      config
    );
    if (data?.success === true) {
      dispatch({ type: ADD_TEACHER_SUCCESS, payload: data });
      message.success(data?.message || "Teacher details added successfully");
    } else {
      throw new Error(data?.message || "Failed to teacher details");
    }
  } catch (error) {
    dispatch({
      type: ADD_TEACHER_FAIL,
      payload:
        error?.response?.data?.message ||
        error?.message ||
        "Failed to teacher details",
    });
    message.error(
      error?.response?.data?.message || "Failed to teacher details"
    );
  }
};

// Get Teachers
export const getTeachers = () => async (dispatch) => {
  try {
    dispatch({ type: GET_TEACHERS_REQUEST });

    const { data } = await axios.get("/api/v1/teachers/admin-get-teacher");

    dispatch({
      type: GET_TEACHERS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_TEACHERS_FAIL,
      payload: error?.response?.data?.message || error?.message,
    });
  }
};

// Update Teacher
export const updateTeacher = (formData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_TEACHER_REQUEST });
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    const { data } = await axios.put(
      "/api/v1/teachers/admin-update-teacher",
      formData,
      config
    );
    
    if (data?.success === true) {
      dispatch({ type: UPDATE_TEACHER_SUCCESS, payload: data });
      message.success(data?.message || "Teacher details updated successfully");
    } else {
      throw new Error(data?.message || "Failed to update teacher details");
    }
  } catch (error) {
    dispatch({
      type: UPDATE_TEACHER_FAIL,
      payload:
        error.response?.data?.message ||
        error?.message ||
        "Failed to update teacher details",
    });
    message.error(
      error?.response?.data?.message || "Failed to update teacher details"
    );
  }
};

// Delete Teacher
export const deleteTeacher = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_TEACHER_REQUEST });

    const response = await axios.delete(
      `/api/v1/teachers/admin-delete-teacher`,
      {
        data: { id },
      }
    );

    if (response?.data?.success === true) {
      dispatch({ type: DELETE_TEACHER_SUCCESS, payload: id });
      message.success(
        response?.data?.message || "Teacher deleted successfully"
      );
    } else {
      throw new Error(
        response?.data?.message || "Failed to delete teacher details"
      );
    }
  } catch (error) {
    dispatch({
      type: DELETE_TEACHER_FAIL,
      payload:
        error.response?.data?.message ||
        error?.message ||
        "Failed to delete teacher details",
    });
    message.error(
      error?.response?.data?.message || "Failed to delete teacher details"
    );
  }
};

// Clearing Errors
export const clearErrors = () => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
};
